import React, { useState } from "react";
import { Button, Menu, MenuButton, MenuList, MenuDivider, MenuOptionGroup, MenuItemOption, Box } from "@chakra-ui/react";
import { ChevronDownIcon } from "../../../Assets/images/svgs";
import "./styles.css";

const Select = ({ options, defaultValue, multi, selectAll, selected, onChange, defaultOption, label, icon, isOpen, width, menuButtonClass, menuButtonClick, menuListClass }) => {
  const getDefaultSelected = () => {
    if (defaultValue) return defaultValue;

    if (multi) {
      if (selectAll) return options.map(({ value }) => value);
      else return [];
    }
  };

  const [ allSelected, setAllSelected ] = useState(Boolean(selectAll));
  const [ selectedOptions, setSelectedOptions ] = useState(getDefaultSelected());
  const value = selected || selectedOptions;

  const handleSelectAll = () => {
    if (value.length === options.length) {
      handleChange([]);
    } else {
      handleChange(options.map(({ value }) => value));
    }
  };

  const handleChange = (e) => {
    if (selectAll) {
      if (options.length === e.length) setAllSelected(true);
      else setAllSelected(false);
    }

    setSelectedOptions(e);
    if (onChange) onChange(e);
  };

  const handleOption = (option) => {
    if (option.onClick) option.onClick();
    if (!multi) handleChange(option.value);
  };

  const getLabel = () => {
    if (label) return label;

    if (!multi) {
      if (value) return options.find((option) => option.value === value).label;
      return defaultOption || "Select Option";
    } else {
      if (value.length) {
        if (value.length === options.length) return selectAll ? selectAll.label : `All Selected`;
        else return `${value.length} Selected`;
      }
      return defaultOption || "Select Options";
    }
  };

  const handleMenuButtonClick = () => {
    if (menuButtonClick) menuButtonClick();
  }

  return (
    <Box>
      <Menu closeOnSelect={!multi} isOpen={isOpen}>
        <MenuButton onClick={handleMenuButtonClick} as={Button} leftIcon={icon} rightIcon={<ChevronDownIcon />} className={`menu-button ${menuButtonClass}`} width={width}>
          {getLabel()}
        </MenuButton>

        <MenuList className={`menu-list ${menuListClass}`} width={width} zIndex={5}>
          {selectAll && (
            <MenuOptionGroup value={allSelected ? [allSelected] : []} onChange={handleSelectAll} type={"checkbox"}>
              <MenuItemOption value={true}>{selectAll.label}</MenuItemOption>
              <MenuDivider className="menu-divider" />
            </MenuOptionGroup>
          )}

          <MenuOptionGroup value={value} onChange={multi ? handleChange : null} type={multi ? "checkbox" : "radio"}>
            {options.map((option) => (
              <MenuItemOption key={option.value} value={option.value} onClick={() => handleOption(option)}>
                <div className="menu-option-container">
                  <p className="option-label">{option.label}</p>
                  {(option.count || option.count === 0) ? <p className="option-count">{`${option.count} in stock`}</p> : null}
                </div>
              </MenuItemOption>
            ))}
          </MenuOptionGroup>
        </MenuList>
      </Menu>
    </Box>
  );
};

export default Select;
